module.exports = __webpack_public_path__ + "static/img/blo6.e755e826.png";